import React from 'react';

import { InputRow } from '../../../../helpers/uiComponents/InputRow';
import { ActionTabs } from '../../../../helpers/uiComponents/ActionTabs';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';

import { hidePopup, showPopup, showMessage, hideMessage } from '../../../../helpers/uiFunctions/uiActions';
import { saveCredential, getCredentials, deleteCredential } from '../../../../data/serviceClients';

export class ConnectedServices extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			credentials: [],
		}
		this.updateCredential = this.updateCredential.bind(this);
	}
	componentDidMount() {
		getCredentials(this.props.currentClient.clientCode).then(credentials => {
			if (credentials.success === true) {
				var result = credentials.result.sort((a, b) => (a.group > b.group) ? 1 : -1);
				this.setState({
					credentials: result,
				});
			} else {
				console.log("there was an issue fetching the client credentials");
			}
		});
	}
	updateCredential(e) {
		var id = e.target.attributes.customdata.value;
		id = parseInt(id, 10);
		var key = e.target.name;
		var value = e.target.value;

		if (e.target.type === "checkbox") {
			value = e.target.checked;
		}

		const keyIndex = this.state.credentials.findIndex(cred => cred.id === id )
        let newState = this.state.credentials;
        newState[keyIndex] = {...newState[keyIndex], [key]: newState[keyIndex][key] = value}

        this.setState({credentials: newState});
		// console.log(id, key, value, newState);
	}
	handleCredential(action) {
		var body = {};
		if(action === "save") {
			showMessage("Saving External Services...");
			for (let i = 0; i < this.state.credentials.length; i++) {
				body = this.state.credentials[i];
				// console.log(body);
				saveCredential(body).then(data => {
					// console.log(data);
					hideMessage(data.success);
				});
			}
		} else {
			showMessage("Adding External Service...");
			var obj = document.getElementById("credential-select");
			var type = obj.options[obj.selectedIndex].getAttribute('data-type');
			var group = obj.options[obj.selectedIndex].getAttribute('data-group');
			var platform = obj.options[obj.selectedIndex].getAttribute('data-platform');
			// console.log(type, group, platform);
			body = {
				"clientCode": this.props.currentClient.clientCode,
				"siteCode": "all",
				"instance": "prod",
				"type": type,
				"platform": platform,
				"group": group,
				"active": false,
			}
			saveCredential(body).then(data => {
				if (data.success === true) {
					hidePopup("new-credential");
					hideMessage(data.success);
					var newState = this.state.credentials;
					newState.push(data.result);
					newState = newState.sort((a, b) => (a.group > b.group) ? 1 : -1);
					this.setState({ credentials: newState });
				}
			});
		}
	}
	delete(id) {
		showMessage("Deleting External Services...");
		deleteCredential(id).then(data => {
			if (data.success === true) {
	        	var update = this.state.credentials;
				for (var i = update.length - 1; i >= 0; i--) {
					if ( update[i].id === id ) {
						update.splice([i], 1);
					}
				}
				this.setState({credentials: update});
				hideMessage(data.success);
	        }
		})
	}
	platformName(platform, type) {
		if (platform === "superMetrics") { platform = type }
		if (platform === "swell") {
			platform = platform+type;
		}
		let names = {
			"evaunt": "evaunt",
			"facebookVerify": "Facebook Verify Meta Tag",
			"twilio" : "Twilio",
			"qfloors": "QFloors",
			"builderPrime" : "Builder Prime",

			"angiesList" : "Social - Angies List",
			"facebook" : "Social - Facebook",
			"googleBusiness" : "Social - Google Business",
			"googlePlus" : "Social - Google Plus",
			"homeAdvisor" : "Social - Home Advisor",
			"houzz" : "Social - Houzz",
			"instagram" : "Social - Instagram",
			"linkedin" : "Social - LinkedIn",
			"pinterest" : "Social - Pinterest",
			"twitter" : "Social - Twitter",
			"yelp" : "Social - Yelp",
			"youTube" : "Social - YouTube",

			"fbAccount": "Insight - Facebook Reporting : Super Metrics API",
			"googleMyBusiness": "Insight - Google My Business : Super Metrics API",
			"googleAnalytics": "Insight - Google Analytics : Super Metrics API",
			"googleAnalytics4": "Insight - Google Analytics 4 : Super Metrics API",
			"googleAdwords": "Insight - Google Adwords : Super Metrics API",
			"searchConsole": "Insight - Search Console : Super Metrics API",
			"getStat": "Insight - getStat Keyword Report API",

			"shawFlooringNetwork" : "Shaw Flooring Network",
			"shawNow" : "Shaw Now",
			"shawWebStudio" : "Shaw Web Studio",
			"shawProd" : "Shaw Product API",

			"rlm" : "RLM",
			"rfms" : "RFMS",
			"sharpSpring" : "Sharp Spring",
			"vtiger" : "vTiger",

			"swellchat": "Swell Chat Embed Widget",
			
			"swellreview": "Swell Reviews Embed Widget",
			"swellkey": "Swell API Key",

			"benjaminMoore": "Benjamin Moore Paints",
			"simpliFi": "Insight Simpli.Fi API",
			"fibi": "FiBi",
			"floorlytics": "Floorlytics Script",
			"callTrackingMetricsScript": "Call Tracking Metrics Embed Script",
			"mosaic": "Mosaic Script",
			"yext": "Yext Reviews Embed Widget",
		};
		if (names[platform]) {
			// console.log(names[platform]);
			return (names[platform]);
		} else {
			// console.log("undefined");
			return (platform);
		}
	}

	render () {
		const { credentials } = this.state;

		return (
			<div className="input-group">
				<AccordianTitle title={"External Services"} />
				<div className="accordian-body">
					<em>CRMs, Shaw Accounts, Social Media, etc...</em>
					<ActionTabs
						handleAdd={() => showPopup("new-credential")}
						handleSave={() => this.handleCredential("save")}
						id={"credentials"}
					/>
					<div id="new-credential">
						<div className="new-credential">
							<div className="select">
								<select name="credential-select" id="credential-select">

								<option data-type="accessibility" data-group="communication" data-platform="audioeye">Communications - Audioeye</option>
									<option data-type="review" data-group="communication" data-platform="Birdeye">Communications - Birdeye Review</option>
									<option data-type="chat" data-group="communication" data-platform="podium">Communications - Podium</option>
									{/* <option data-type="key" data-group="communication" data-platform="swell">Communications - Swell API Key</option> */}
									<option data-type="chat" data-group="communication" data-platform="swell">Communications - Swell Chat</option>
									<option data-type="review" data-group="communication" data-platform="swell">Communications – Swell Review</option>
									<option data-type="review" data-group="communication" data-platform="yext">Communications – Yext Review</option>
									<option data-type="sms" data-group="communication" data-platform="twilio">Communications - Twilio</option>
									<option data-type="chat" data-group="communication" data-platform="tidio">Communications - Tidio</option>
									<option data-type="chat" data-group="communication" data-platform="fibi">Communications - FiBi</option>
									<option data-type="chat" data-group="communication" data-platform="floorlytics">Communications - Floorlytics Script</option>
									<option data-type="chat" data-group="communication" data-platform="mosaic">Communications - Mosaic Script</option>
									<option data-type="chat" data-group="communication" data-platform="callTrackingMetricsScript">Communications - Call Tracking Metrics Embed Script</option>
									<option data-type="crm" data-group="crm" data-platform="builderPrime">CRM - Builder Prime</option>
									<option data-type="crm" data-group="crm" data-platform="coretecData">CRM - Coretec Data</option>
									<option data-type="crm" data-group="crm" data-platform="pacsol">CRM - Pacific Solutions</option>
									<option data-type="crm" data-group="crm" data-platform="qfloors">CRM - QFloors</option>
									<option data-type="crm" data-group="crm" data-platform="hubspot">CRM - Hubspot</option>
									<option data-type="crm" data-group="crm" data-platform="rfms">CRM - RFMS</option>
									<option data-type="crm" data-group="crm" data-platform="rlm">CRM - RLM</option>
									<option data-type="crm" data-group="crm" data-platform="rollmaster">CRM - Rollmaster</option>
									<option data-type="crm" data-group="crm" data-platform="salesforce">CRM - Salesforce</option>
									<option data-type="crm" data-group="crm" data-platform="sharpSpring">CRM - Sharp Spring</option>
									<option data-type="crm" data-group="crm" data-platform="vtiger">CRM - vTiger</option>
									<option data-type="crm" data-group="crm" data-platform="zendesk">CRM - Zendesk</option>
									<option data-type="crm" data-group="crm" data-platform="zendeskSell">CRM - Zendesk Sell</option>
									<option data-type="crm" data-group="crm" data-platform="zoho">CRM - Zoho</option>
									

									<option data-type="fbVerify" data-group="reporting" data-platform="facebookVerify">Insight - Facebook Verify</option>
									<option data-type="getstat" data-group="reporting" data-platform="getStat">Insight - getStat Keyword API</option>
									<option data-type="fbAccount" data-group="reporting" data-platform="superMetrics">Insight - Facebook : Super Metrics API</option>
									<option data-type="googleMyBusiness" data-group="reporting" data-platform="superMetrics">Insight - Google My Business : Super Metrics API</option>
									<option data-type="googleAnalytics" data-group="reporting" data-platform="superMetrics">Insight - Google Analytics : Super Metrics API</option>
									<option data-type="googleAnalytics4" data-group="reporting" data-platform="superMetrics">Insight - Google Analytics 4 : Super Metrics API</option>
									<option data-type="simplifi" data-group="reporting" data-platform="simpliFi">Insight Simpli.Fi api</option>
									<option data-type="googleAdwords" data-group="reporting" data-platform="superMetrics">Insight - Google Adwords : Super Metrics API</option>
									<option data-type="searchConsole" data-group="reporting" data-platform="superMetrics">Insight - Search Console : Super Metrics API</option>
									{(this.props.currentClient.clientCode === "area") && (
										<option data-type="rugShop" data-group="reporting" data-platform="rugShop">Insight - Rugs.Shop Sales</option>
									)}
									<option data-type="evaunt" data-group="account" data-platform="evaunt">Misc - Evaunt</option>
									<option data-type="floorvana" data-group="floorvana" data-platform="Floorvana">MISC - Floorvana Dealer Key</option>

                                    <option data-type="paint" data-group="productAPI" data-platform="benjaminMoore">Products - Paint - Benjamin Moore</option>

									<option data-type="sfn" data-group="shaw" data-platform="ShawFlooringNetwork">Shaw - Shaw Flooring Network</option>
									<option data-type="sn" data-group="shaw" data-platform="ShawNow">Shaw - Shaw Now</option>
									<option data-type="sws" data-group="shaw" data-platform="ShawWebStudio">Shaw - Shaw Web Studio</option>
									<option data-type="shawProd" data-group="shaw" data-platform="ShawProductAPI">Shaw - Shaw Product API</option>

									<option data-type="anglst" data-group="social" data-platform="angiesList">Social - Angies List</option>
									<option data-type="fb" data-group="social" data-platform="facebook">Social - Facebook</option>
									<option data-type="glbs" data-group="social" data-platform="googleBusiness">Social - Google Business</option>
									<option data-type="glpl" data-group="social" data-platform="googlePlus">Social - Google Plus</option>
									<option data-type="hmadv" data-group="social" data-platform="homeAdvisor">Social - Home Advisor</option>
									<option data-type="hzz" data-group="social" data-platform="houzz">Social - Houzz</option>
									<option data-type="insta" data-group="social" data-platform="instagram">Social - Instagram</option>
									<option data-type="lnkd" data-group="social" data-platform="linkedin">Social - LinkedIn</option>
									<option data-type="pin" data-group="social" data-platform="pinterest">Social - Pinterest</option>
									<option data-type="twit" data-group="social" data-platform="twitter">Social - Twitter</option>
									<option data-type="ylp" data-group="social" data-platform="yelp">Social - Yelp</option>
									<option data-type="yt" data-group="social" data-platform="youTube">Social - YouTube</option>
								</select>
								<div className="select_arrow"></div>
							</div>
							<input type="button" className="button" value="Add" onClick={() => this.handleCredential("add")} />
							<i className="fas fa-times icon" onClick={() => hidePopup("new-credential")}></i>
						</div>
					</div>

					{(credentials) && (
						<div id="all-credentials">
							{(credentials.map(cred =>
								(cred.type
								&& cred.platform
								&& cred.platform !== "quickbooks"
								&& cred.platform !== null
								&& cred.platform !== "") && (
									<div className={"credential credential-"+cred.id} key={cred.id}>
										<button className="button" onClick={() => this.delete(cred.id)}><i className="far fa-trash-alt icon"></i></button>
										<h4>{this.platformName(cred.platform, cred.type)}</h4>

										<input type="hidden" name="id" value={cred.id} />
										<input type="hidden" name="clientCode" value={cred.clientCode} />
										<input type="hidden" name="instance" value="all" />
										<input type="hidden" name="group" value={cred.group} />
										<input type="hidden" name="type" value={cred.type} />
										<input type="hidden" name="platform" value={cred.platform} />

										<InputRow onChange={this.updateCredential} data={cred.id} label="Active?" type="checkbox" value={cred.active} property="active" />
										<InputRow onChange={this.updateCredential} data={cred.id} label="Testing Credential?" type="checkbox" value={cred.testing} property="testing" description="limits interactions with this credential to only testing. no production interactions will happen." />

										{(cred.type === "crm") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Push Leads?" type="checkbox" value={cred.pushLeads} property="pushLeads" />
											</React.Fragment>
										)}

										{(cred.type === "crm" && (cred.platform === "rfms" || cred.platform === "qfloors")) && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Pull Order?" type="checkbox" value={cred.pullOrders} property="pullOrders" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Pull Products?" type="checkbox" value={cred.pullProducts} property="pullProducts" />
											</React.Fragment>
										)}

										{(cred.platform === "audioeye") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Access Key" type="text" value={cred.key} property="key" />
											</React.Fragment>
										)}
										{(cred.platform === "Birdeye") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Review Url" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Main Business Id" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Business Ids" type="text" value={cred.accountId} property="accountId" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="API Key" type="text" value={cred.key} property="key" />
												
											</React.Fragment>
										)}

										{(cred.platform === "podium"  && cred.type !== "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Embed Script" type="text" value={cred.script} property="script" />
										)}
										{(cred.platform === "swell" && cred.type !== "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Embed Script" type="text" value={cred.script} property="script" />
										)}
										{(cred.platform === "swell" && cred.type === "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="API Key" type="text" value={cred.key} property="key" />
										)}
										{(cred.platform === "yext" && cred.type !== "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Embed Script" type="text" value={cred.script} property="script" />
										)}
										{(cred.platform === "tidio") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Username" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Password" type="text" value={cred.password} property="password" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Script src" type="text" value={cred.url} property="url" />
											</React.Fragment>
										)}

										{(cred.platform === "fibi" && cred.type !== "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Embed Script" type="text" value={cred.script} property="script" />
										)}

										{(cred.platform === "floorlytics" && cred.type !== "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Embed Script" type="text" value={cred.script} property="script" />
										)}

										{(cred.platform === "callTrackingMetricsScript") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Call Tracking ID" type="text" value={cred.key} property="key" />
										)}

										{(cred.platform === "mosaic" && cred.type !== "key") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Embed Script" type="text" value={cred.script} property="script" />
										)}

										{(cred.platform === "twilio") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Phone Number" type="text" value={cred.username} property="username" />
										)}
										{(cred.platform === "zendesk") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="User Email" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="API Key" type="text" value={cred.key} property="key" />
											</React.Fragment>
										)}
										{(cred.platform === "zendeskSell") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Personal Access Token" type="text" value={cred.token} property="token" />
											</React.Fragment>
										)}
										{(cred.platform === "zoho") && (
                                            <React.Fragment>
                                               <InputRow onChange={this.updateCredential} data={cred.id} label="Client Id" type="text" value={cred.accountId} property="accountId" />
                                               <InputRow onChange={this.updateCredential} data={cred.id} label="Client Secret" type="text" value={cred.secret} property="secret" />
                                               <InputRow onChange={this.updateCredential} data={cred.id} label="Refresh Token" type="text" value={cred.token} property="token" />
                                            </React.Fragment>
                                        )}
										{(cred.platform === "hubspot") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Private App Token" type="text" value={cred.token} property="token" />
											</React.Fragment>
										)}
										{(cred.group === "social" || cred.type === "sfn" || cred.type === "sws" || cred.type === "sn" ) && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
										)}
										{(cred.type === "sws" || cred.type === "shawProd") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Shaw Account ID" type="text" value={cred.accountId} property="accountId" />
										)}
										{(cred.type === "shawProd") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="DEALER API KEY" type="text" value={cred.key} property="key" />
										)}
										{(cred.platform === "rollmaster") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Username" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Password" type="text" value={cred.password} property="password" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Branch" type="text" value={cred.path} property="path" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Access Key" type="text" value={cred.key} property="key" />
											</React.Fragment>
										)}
										{(cred.platform === "Floorvana") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Floorvana Dealer Key" type="text" value={cred.key} property="key" />
										)}
										{(cred.type === "san" || cred.platform === "superMetrics") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Account ID" type="text" value={cred.accountId} property="accountId" />
										)}
										{(cred.type === "fbVerify") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Name" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Content" type="text" value={cred.accountId} property="accountId" />
											</React.Fragment>
										)}
										{(cred.platform === "getStat") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Site ID" type="text" value={cred.accountId} property="accountId" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="API Key" type="text" value={cred.key} property="key" />
											</React.Fragment>
										)}
										{(cred.platform === "builderPrime") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="API Key" type="text" value={cred.key} property="key" />
											</React.Fragment>
										)}
										{(cred.platform === "pacsol") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Host" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Database" type="text" value={cred.key} property="key" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Layout" type="text" value={cred.secret} property="secret" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Script Name" type="text" value={cred.script} property="script" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Script Parameters" type="text" value={cred.params} property="params" />
											</React.Fragment>
										)}
										{(cred.platform === "evaunt") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Keyword" type="text" value={cred.accountId} property="accountId" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Mobile Card URL" type="text" value={cred.url} property="url" />
											</React.Fragment>
										)}
										{(cred.platform === "vtiger" || cred.group === "social" || cred.platform === "qfloors" || cred.type === "sfn" || cred.type === "sws" || cred.type === "sn" || cred.platform === "pacsol") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Username" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Password" type="text" value={cred.password} property="password" />
											</React.Fragment>
										)}
										{(cred.platform === "qfloors") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="Company ID" type="text" value={cred.accountId} property="accountId" />
										)}
										{(cred.platform === "vtiger") && (
											<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
										)}
										{(cred.platform === "rlm") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Org ID" type="text" value={cred.accountId} property="accountId" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Org API" type="text" value={cred.key} property="key" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Pipeline API" type="text" value={cred.secret} property="secret" />
											</React.Fragment>
										)}
										{(cred.platform === "rfms") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Has CRM Module?" type="checkbox" value={cred.hasModule} property="hasModule" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Using Project Manager?" type="checkbox" value={cred.useProjectManager} property="useProjectManager" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Using BidPro?" type="checkbox" value={cred.useBidPro} property="useBidPro" />
												{cred.useBidPro && (
													<InputRow
														onChange={this.updateCredential}
														data={cred.id}
														label="Model Name"
														type="text"
														value={cred.modelName}
														property="modelName"
													/>
												)}
												<InputRow onChange={this.updateCredential} data={cred.id} label="Business ID  (Additional process required. Contact Steve)" type="text" value={cred.token} property="token" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Store Queue" type="text" value={cred.accountId} property="accountId" />
											</React.Fragment>
										)}
										{(cred.platform === "sharpSpring") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Account Id" type="text" value={cred.accountId} property="accountId" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Secret" type="text" value={cred.secret} property="secret" />
											</React.Fragment>
										)}
										{(cred.platform === "rugShop") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Integration Secret Key" type="text" value={cred.secret} property="secret" />
											</React.Fragment>
										)}
										{(cred.platform === "salesforce") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="URL" type="text" value={cred.url} property="url" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Username" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Password" type="text" value={cred.password} property="password" />

												<InputRow onChange={this.updateCredential} data={cred.id} label="Client Key" type="text" value={cred.key} property="key" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Client Secret" type="text" value={cred.secret} property="secret" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="Security Token" type="text" value={cred.token} property="token" />
											</React.Fragment>
										)}
										{(cred.platform === "benjaminMoore") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="API Key" type="text" value={cred.key} property="key" />
											</React.Fragment>
										)}

										{(cred.platform === "simpliFi") && (
											<React.Fragment>
												<InputRow onChange={this.updateCredential} data={cred.id} label="Organization Id" type="text" value={cred.accountId} property="accountId" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="X-User-Key" type="text" value={cred.username} property="username" />
												<InputRow onChange={this.updateCredential} data={cred.id} label="X-App-Key" type="text" value={cred.password} property="password" />
											</React.Fragment>
										)}

									</div>
								))
							)}
						</div>
					)}

				</div>
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/Credentials.js